import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

import i18n from './locales' // 配置多语言环境

import './styles.css' // 导入样式文件,tailwindcss相关

import '@/assets/fonts/fonts.css' // 导入字体文件

import VueVideoPlayer from '@videojs-player/vue' // 导入视频播放器组件
import 'video.js/dist/video-js.css'

// import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
// import { library } from '@fortawesome/fontawesome-svg-core';
// import { faTimes, faCheck } from '@fortawesome/free-solid-svg-icons'; // 仅引入需要的 Solid 图标
// import { faStar } from '@fortawesome/free-regular-svg-icons'; // 仅引入需要的 Regular 图标
import '@fortawesome/fontawesome-free/css/all.min.css'; // 导入所有图标样式

// 将图标添加到库中
// library.add(faTimes, faCheck, faStar);

import directives from './directives'; // 导入自定义指令

const app = createApp(App);
// app.component('font-awesome-icon', FontAwesomeIcon); // 注册组件
app.use(VueVideoPlayer)
app.use(i18n)
app.use(router)
app.use(directives) // 注册自定义指令
   .mount('#app');
  